import moment from 'moment-timezone';

export const MINUTE_SECONDS = 60;
export const HOUR_SECONDS = MINUTE_SECONDS * 60;
export const DAY_SECONDS = HOUR_SECONDS * 24;

export const HOUR_MINUTES = 60;
export const DAY_MINUTES = HOUR_MINUTES * 24;

export const MINUTE_MS = 1000 * 60;
export const HOUR_MS = MINUTE_MS * 60;
export const DAY_MS = HOUR_MS * 24;
export const DAYS_60 = 60 * DAY_MS;
export const DAYS_30 = 30 * DAY_MS;

export function weeksToIso8601Days(weeks: number | null): string | null {
  if (weeks == null) {
    return null;
  }
  return moment.duration({ days: weeks * 7 }).toISOString();
}

export function iso8601DaysToWeeks(duration: string | null | undefined): number | null {
  if (!duration) {
    return null;
  }
  const weeks = moment.duration(duration).asWeeks();
  return isFinite(weeks) && weeks > 0 ? Math.round(weeks) : null;
}
